import { render, staticRenderFns } from "./Createm.vue?vue&type=template&id=7b97c052"
import script from "./Createm.vue?vue&type=script&lang=js"
export * from "./Createm.vue?vue&type=script&lang=js"
import style0 from "./Createm.vue?vue&type=style&index=0&id=7b97c052&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports